import * as React from "react";
import { Props } from "./config";
import { Box, Link, Stack, ThemeProvider, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import theme from "theme/theme";
import { Modal } from "components/Modal";

const ConfirmActionModal: React.FC<Props> = ({
  onConfirm,
  onDecline,
  onDismiss,
  title,
  message,
  extraContent,
  confirmButtonText,
  declineButtonText,
  hasLink,
  linkText,
  linkUrl,
  show,
}) => {
  const confirm = () => {
    onConfirm();
    if (onDismiss) {
      onDismiss();
    }
  };

  const decline = () => {
    if (onDismiss) {
      onDismiss();
    }
    if (onDecline) {
      onDecline();
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal
        title={title ?? "Confirm Action"}
        open={show}
        size="small"
        onClose={decline}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <Typography variant="body1">{message}</Typography>
          {extraContent}

          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            mt={2}
          >
            {hasLink && (
              <Link href={linkUrl} target="_blank" variant="body2">
                {linkText ?? "Learn More"}
              </Link>
            )}
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
            mt={2}
          >
            <Button variant="outlined" color="primary" onClick={decline}>
              {declineButtonText ?? "Cancel"}
            </Button>
            <Button variant="contained" color="primary" onClick={confirm}>
              {confirmButtonText ?? "Confirm"}
            </Button>
          </Stack>
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default ConfirmActionModal;
